<template>
  <div class="roaming-containBox">
    <div class="roaming-containBox-list">
      <div class="roaming-content" v-if="roamingData?.length">
        <div
          class="roaming-content-item"
          v-for="(item, index) in roamingData"
          :key="index"
        >
          <div class="roaming-content-item-title">
            <div class="roaming-content-item-title-text" :title="item.name">
              {{ item.name }}
            </div>
          </div>
          <div class="roaming-content-item-play">
            <div class="roaming-content-item-play-btn-box">
              <el-button
                size="small"
                :disabled="!item.isHasViewPorts || item.selfRoamIsRun"
                plain
                @click="item.isPlay ? playRoam(item) : pauseRoam(item)"
                class="normal-btn primary-ang-btn"
                >{{ item.isPlay ? "播放" : "暂停" }}</el-button
              >
              <el-button
                :disabled="!item.isHasViewPorts || item.selfRoamIsRun"
                size="small"
                plain
                @click="stopRoam(item)"
                class="normal-btn primary-ang-btn"
                >停止</el-button
              >
            </div>
            <div class="roaming-content-item-play-speed-box">
              漫游速度：{{ getRoamSpeed(item) }}
            </div>
          </div>
        </div>
      </div>
      <div class="emptyData" v-else>
        <bj-empty
          :image="require('@/assets/img/no-data.png')"
          class="empty-page"
        >
          <template slot="description">
            <span class="empty-text">暂无漫游路径</span>
          </template>
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getRoamList,
  getRoamDetails,
} from "@/service/share/sceneShareInterface.js";
import { roamingPlay, roamingStop, roamingPause } from "./";
import { getCameraViewAngle } from "@/utils/engineUtils";

export default {
  data() {
    return {
      roamingData: [],
      speedUnitList: [
        {
          label: "m/s",
          value: "Meter",
        },
        {
          label: "km/s",
          value: "Kilometer",
        },
      ],
      pauseInfoList: [],
      isRunRoam: false,
      isPauseId: "",
      playRoamItem: {},
    };
  },
  computed: {
    getSceneId() {
      return this.$route.params.resourceId;
    },
  },
  methods: {
    // 获取列表最大索引
    findMaxIndex(arr = []) {
      // 容错处理：空数组直接返回初始序号
      if (!arr.length) return 1;
      // 使用正则提取数字，避免 split 误分割
      const pattern = /漫游(\d+)/;
      let max = -Infinity;

      // 单次遍历同时完成有效值过滤和最大值计算
      for (const { name } of arr) {
        const match = name?.match(pattern);
        const num = match ? parseInt(match[1], 10) : NaN;
        if (!isNaN(num) && num > max) {
          max = num;
        }
      }
      return max !== -Infinity ? max + 1 : 1;
    },
    async getRoamList(item) {
      let headers = this.getHeaders();
      const data = await getRoamList(this.getSceneId, headers);
      if (data?.isSuccess) {
        this.roamingData =
          data?.data.map((item) => {
            return {
              ...item,
              isPlay: true,
              selfRoamIsRun: false,
            };
          }) ?? [];
      } else {
        this.roamingData = [];
        this.$message.error(data.errMsg);
      }
    },

    // 获取漫游数据
    async getRoamListViewPort(item) {
      const roamingInfo = await this.editRoamInfo(item.sceneRoamId);
      const infoList = roamingInfo.viewPorts.map((item) => item.visualAngle);
      const roamSpeedUnit = roamingInfo.speedUnit === "Meter" ? 1 : 1000;
      const totalRoamSpeed = Number(item.speed) * roamSpeedUnit;
      return {
        ...roamingInfo,
        totalRoamSpeed,
        viewPorts: infoList,
      };
    },
    // 编辑漫游信息
    async editRoamInfo(id) {
      this.saveRoamId = id;
      const { isSuccess, errMsg, data } = await this.getRoamDetails(id);
      if (!isSuccess) {
        return this.$message.error(errMsg);
      }
      return data;
    },
    // 获取漫游详情
    async getRoamDetails(id = this.saveRoamId) {
      let headers = this.getHeaders();
      const detailInfo = await getRoamDetails(id, headers);
      if (!detailInfo?.isSuccess) {
        return this.$message.error(detailInfo.errMsg);
      }
      this.roamingInfo = detailInfo.data;
      this.roamingInfo.viewPorts = detailInfo.data?.viewPorts.map((item) => {
        return {
          ...item,
          thumbnail: `${window.imageBaseUrl}/` + item?.thumbnail,
          editName: false,
        };
      });
      return detailInfo;
    },
    //开始播放
    async playRoam(item) {
      if (this.isPauseId && this.isPauseId !== item?.sceneRoamId) {
        this.pauseInfoList = [];
      }
      this.playRoamItem = item;
      this.isPauseId = item.sceneRoamId;
      let playRoam;
      const roamingInfo = await this.getRoamListViewPort(item);
      if (roamingInfo?.viewPorts?.length === 0) {
        return;
      }
      if (!this.pauseInfoList?.length) {
        playRoam = roamingInfo.viewPorts;
      } else {
        playRoam = this.pauseInfoList;
      }
      item.isPlay = false;
      this.isRunRoam = true;

      this.roamingData.forEach((list) => {
        if (list.sceneRoamId !== item.sceneRoamId) {
          list.selfRoamIsRun = true;
        }
      });

      roamingPlay(playRoam, roamingInfo.totalRoamSpeed, item, this.playRoamEnd);
    },

    // 暂停播放
    async pauseRoam(item) {
      const currentIndex = roamingPause();
      const roamingInfo = await this.getRoamListViewPort(item);
      let playRoamList;
      if (!this.pauseInfoList?.length) {
        playRoamList = roamingInfo.viewPorts;
      } else {
        playRoamList = this.pauseInfoList;
      }
      const currentViewPort = getCameraViewAngle();
      item.isPlay = true;
      this.isRunRoam = false;
      this.roamingData.forEach((list) => {
        list.selfRoamIsRun = false;
      });
      window.BlackHole3D.Camera.setCamLocateTo(
        JSON.parse(currentViewPort),
        0,
        1
      );
      const cameraPositionList = playRoamList.slice(currentIndex);
      const cameraPositionListInfo = [currentViewPort, ...cameraPositionList];
      this.pauseInfoList = cameraPositionListInfo;
    },

    // 漫游播放结束
    playRoamEnd(item) {
      item.isPlay = true;
      this.pauseInfoList = [];
      this.roamingData.forEach((list) => {
        list.selfRoamIsRun = false;
      });
      this.isPauseId = "";
    },
    // 停止漫游
    async stopRoam(item) {
      if (!Object.keys(item).length) {
        return;
      }
      this.pauseInfoList = [];
      this.isPauseId = "";
      item.isPlay = true;
      this.isRunRoam = false;
      this.roamingData.forEach((list) => {
        list.selfRoamIsRun = false;
      });
      const roamingInfo = await this.getRoamListViewPort(item);
      roamingStop(roamingInfo.viewPorts);
    },
    getRoamSpeed(roamInfo) {
      let find = this.speedUnitList.find(
        (el) => el.value === roamInfo.speedUnit
      );
      return `${roamInfo.speed}${find.label}`;
    },
    getHeaders() {
      let token = this.$route.query.token;
      let headers = {
        Authorization: token,
      };
      return headers;
    },
  },
  async mounted() {
    this.getRoamList();
  },
};
</script>

<style scoped lang="less">
@import "@/assets/css/publishSearch.less";

.roaming-containBox {
  padding: 16px;
  padding-top: 8px;
  height: 100%;

  &-edit {
    height: 100%;
  }

  &-list {
    height: 100%;
  }
  .addRoaming {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    :deep(span) {
      display: inline-block;
    }
  }

  .roaming-content {
    margin-top: 8px;
    height: calc(100% - 35px);
    overflow-y: auto;
    &-item {
      border-radius: 8px;
      background: var(--roaming-list-bgColor);
      border: 1px solid var(--roaming-list-border-color);

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      &-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--base-bg-dark-color33);
        height: 32px;
        width: 100%;

        &-text {
          font-size: 14px;
          color: var(--roaming-list-title-text-color);
          margin-left: 8px;
          max-width: calc(100% - 82px);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        &-opera {
          display: flex;
          align-items: center;
          margin-right: 8px;
          :deep(.el-button) {
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            padding: 3px 4px;
            display: flex;
            align-items: center;

            span {
              display: inline-block;
            }
          }
        }
      }

      &-play {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 8px 8px 14px 8px;

        &-btn-box {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          :deep(.el-button) {
            height: 20px;
            font-size: 12px;
            padding: 3px 4px;
            display: flex;
            align-items: center;

            span {
              display: inline-block;
            }
          }
        }

        &-speed-box {
          font-size: 12px;
        }
      }
    }
  }

  .emptyData {
    height: calc(100% - 30px);
    display: flex;
    align-items: center;
    justify-content: center;
    .newPath {
      color: var(--empty-text-color);
      font-size: 12px;
      font-weight: 600;
    }
    :deep(.el-empty__image) {
      width: 260px;
    }
  }
}
</style>
